import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getTenant } from '../../../utils/tenantUtils';

const PhoneBillsAccountStrip = ({ bankAccounts, currentBankAccountId, summaryText }) => {
  const navigate = useNavigate();
  const tenant = getTenant();

  const go = (path) => {
    navigate(tenant ? `/$/${tenant}${path}` : path);
  };

  return (
    <>
      {summaryText && <div className="phone-bills-summary">{summaryText}</div>}
      <div className="phone-bills-account-strip">
        <button
          type="button"
          className={`phone-bills-account-chip ${
            !currentBankAccountId ? 'phone-bills-account-chip--active' : ''
          }`}
          onClick={() => go('/track')}
        >
          All Bills
        </button>
        {bankAccounts.map((account) => (
          <button
            key={account.id}
            type="button"
            className={`phone-bills-account-chip ${
              currentBankAccountId === account.id ? 'phone-bills-account-chip--active' : ''
            }`}
            onClick={() => go(`/track/${account.id}`)}
          >
            {account.nickname}
          </button>
        ))}
      </div>
    </>
  );
};

export default PhoneBillsAccountStrip;
